<template lang="html">
  <section class="actionbar">
    <StudentNotice
      v-if="!!hasStudent"
      :studentInfo="studentInfo"
    ></StudentNotice>
    <SelfPhotoNotice
      v-if="!!isSelfPhoto"
      @readChanged="selfPhotoNoticeChanged"
    ></SelfPhotoNotice>
    <div class="action-list">
      <ul class="action-others" v-if="isAllPayType">
        <!-- 旧的支付方式：只支持全额付款 -->
        <li>
          <span>实付款：</span>
          <p v-if="isTripTicket601 && tripCalendar === null && isNoCalendar">
            -
          </p>
          <!-- 积分实付 -->
          <template v-else-if="isSupportScore">
            <div class="pay-score">{{ payScore }}<span>积分</span></div>
            <div v-if="isLessScore" class="less-score">积分不足</div>
          </template>
          <p v-else>
            <i>&yen;</i><span>{{ price }}</span>
          </p>
        </li>
      </ul>
      <div class="action-prepay" v-else>
        <div class="prepay">
          <span>预付定金:</span>
          <span>&yen;{{ prePrice }}</span>
        </div>
        <div class="nextpay">月嫂上户前再付:&yen;{{ nextPrice }}</div>
      </div>
      <button class="btns btn-pink" v-if="canCreateOrder" @click="confirmBuy">
        提交订单
      </button>
      <button class="btns btn-grey" v-else>提交订单</button>
      <!-- <button class="btns btn-pink" v-else @click="showReason">立即支付</button> -->
    </div>
    <!-- 不要删除-->
    <div class="menu_wkBox_back_box"></div>
  </section>
</template>

<script>
import { mapState, mapMutations, createNamespacedHelpers } from 'vuex'
import { Msgbox } from 'kf-component-vue'
import StudentNotice from '@/components/confirm/student-notice'
import SelfPhotoNotice from '@/components/confirm/selfphoto-notice'
import { SKUTAG, SKUTAGNEED } from '@/plugins/enum'
import http from '@/plugins/http'
import {
  E_PROMOTION_TYPE,
  ORDER_BELONG_BUSI_ENUM,
  InsuranceType
} from '@/config'
import {
  isEmptyObject,
  isNonEmptyArray,
  isNullOrEmpty,
  isString
} from '@/utils'
import { Toast } from 'vant'
import { setOrderId } from '@/business/order/confirmParams'
import { getLatAndLng } from '@/plugins/location'
import { isMiniprogram, isWeixin } from 'kwsdk'
import { MINI_APPID_XYZHG, MINI_APPID_TCHQZ } from '@/constants/appId'
const { mapState: nameSpaceState, mapMutations: mapMutationNs } =
  createNamespacedHelpers('insurance')
export default {
  components: { StudentNotice, SelfPhotoNotice },
  inject: {
    submitTrackParams: {
      default: null
    }
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    isPos: {
      type: Boolean,
      default: false
    },
    //选填的邀请码和备注
    fillIn: {
      type: Object,
      default: () => {}
    },
    //学员信息
    studentInfo: {
      type: Object,
      default: () => {}
    },
    newStoreInfo: {
      type: [Object, null],
      default: null
    },
    isCustomisedGoods: {
      type: Boolean,
      default: false
    },
    isSelfPhoto: {
      type: Boolean,
      default: false
    },
    isAllPayType: {
      type: Boolean,
      default: true
    },
    buyNum: {
      type: Number,
      default: 1
    },
    pickUp: {
      type: Object,
      default: null
    },
    schemeOut: {
      type: Array,
      default: []
    },
    tripCalendar: {
      type: Object,
      default: null
    },
    isNoCalendar: {
      type: Number,
      default: 0
    },
    schemeTravPerson: {
      type: Object,
      default: null
    },
    schemeTicketTaker: {
      type: Object,
      default: null
    },
    hasAddress: {
      type: Boolean,
      default: false
    },
    /* 套餐项目 */
    selectedCombos: {
      type: Array,
      default() {
        return []
      }
    },
    /* 必选套餐项目数 */
    requiredCombosNum: {
      type: Number,
      default: 0
    },
    /* 教育品类权益卡套餐 */
    //选几门课
    optionalCourseNum: {
      type: Number,
      default: 0
    },
    isChooseCourse: {
      type: Number,
      default: 0
    },
    //选择的课程
    selectCourses: {
      type: Array,
      default: () => []
    },
    thirdInfos: {
      type: Array,
      default: []
    },
    spotId: {
      type: String,
      default: ''
    },
    supportInsurance: {
      type: Boolean,
      default: false
    },
    insuranceType: {
      type: Number,
      default: InsuranceType.NONE
    }
  },
  computed: {
    ...nameSpaceState([
      'guardianInfo',
      'selectAdultList',
      'selectChildList',
      'insuranceInfo',
      'startTime'
    ]),
    ...mapState([
      'couponList',
      'selectedWorker',
      'selectedTime',
      'selectedAddress',
      'confirmSelected',
      'isOpenAppCashier',
      'isSupportScore',
      'isLessScore'
    ]),
    ...mapState('promotionInfo', {
      promotionInfo: state => state.promotionInfo,
      selectedCoupon(state) {
        const coupon = state.confirmSelCoupon || {}
        if (isNullOrEmpty(coupon.couponPassword)) return {}
        // console.log('-----selectedcoupon-----', coupon)
        return coupon
      },
      /**
       * 立减活动
       */
      reduceInfo(state) {
        return state.confirmSelDiscount || {}
      },
      /**
       * 立减金额
       * 单位：分
       * 立减订单必传
       */
      reducePrice(state) {
        return this.reduceInfo.promotionPrice || 0
      },
      /**
       * 满赠活动信息
       * 满赠必传
       * @returns {{activityId,giveSkuId,giveSpuId,giveSkuName,giveSpuName}}
       */
      promotionGiveVoList(state) {
        const { promList } = state.promotionInfo
        if (isNullOrEmpty(promList) || !isNonEmptyArray(promList)) return []
        let t = promList.filter(x => +x.type === E_PROMOTION_TYPE.REWARD_GIFT)
        if (isNonEmptyArray(t)) {
          const tmpArr = []
          t.forEach(x => {
            const {
              giftInfo: { skuId, skuName, spuId, spuName, refOrder, specSpu },
              promotionName,
              ruleId
            } = x
            tmpArr.push({
              activityId: ruleId,
              giveSkuId: skuId,
              giveSpuId: spuId,
              giveSkuName: skuName,
              giveSpuName: spuName,
              promotionName,
              refOrder: refOrder,
              endTime: x.endTime,
              specSpu: specSpu
            })
          })

          return tmpArr
        }
        return []
      }
    }),

    price() {
      let price = 0
      let orgPrice = 0
      if (this.tripCalendar && this.tripCalendar.price) {
        orgPrice =
          this.buyNum *
          (this.tripCalendar.customerPrice != null
            ? this.tripCalendar.customerPrice
            : this.tripCalendar.price)
      } else if (this.product && this.product.priceInfo) {
        orgPrice = this.buyNum * this.product.priceInfo.price
      }
      if (this.selectedCoupon && this.selectedCoupon.couponId) {
        price =
          this.selectedCoupon.couponAmount >= orgPrice
            ? 0
            : orgPrice - this.selectedCoupon.couponAmount
      } else {
        price = orgPrice
      }
      // console.log('price', price, this.selectedCoupon, this.reducePrice)
      price = price - this.reducePrice
      if (price < 0) price = 0

      this.setOrderPayPrice(price)
      return `${price / 100}`
    },
    payScore() {
      let payScore = 0
      if (this.product && this.product.priceInfo) {
        payScore = this.buyNum * this.product.priceInfo.payScore
        this.setOrderPayScore(payScore)
        this.setIsLessScore(this.product.userInfo.userPoints < payScore)
      }
      return payScore
    },
    //预付定金
    prePrice() {
      let price = 0
      if (
        this.product &&
        this.product.skuInfo &&
        this.product.skuInfo.payPeriodInfo &&
        this.product.skuInfo.payPeriodInfo.paymentDepositPrice
      ) {
        price = this.product.skuInfo.payPeriodInfo.paymentDepositPrice
      }

      if (price < 0) price = 0
      return `${price / 100}`
    },
    //尾款
    nextPrice() {
      let price = this.price * 100 - this.prePrice * 100
      if (price < 0) price = 0
      return `${price / 100}`
    },
    canCreateOrder() {
      let result = true
      if (this.hasAddress) {
        result = result && this.isNotNullObject(this.selectedAddress)
      }
      if (this.hasStudent) {
        this.customList &&
          this.customList.fields.forEach(item => {
            result = result && !!this.studentInfo[item.labelKey]
          })
        result = result && this.studentInfo.isReaded
      }
      if (this.hasWorker && !this.hideServeCompsYunChanJiaTHG) {
        result = result && this.isNotNullObject(this.selectedWorker)
      }
      if (this.hasTime && !this.hideServeCompsYunChanJiaTHG) {
        result = result && !!this.selectedTime
      }
      if (this.hasStore && !this.hideServeCompsYunChanJiaTHG) {
        result = result && !!this.selectedStore
      }
      if (this.isLessScore) {
        result = false
      }
      return result
    },
    remark() {
      return this.fillIn.remark
    },
    inviteCode() {
      return this.fillIn.inviteCode
    },
    selectedStore() {
      return (
        this.confirmSelected &&
        this.confirmSelected.store &&
        this.confirmSelected.store.store_code
      )
    },
    skuTag() {
      return this.product && this.product.skuInfo && this.product.skuInfo.skuTag
    },
    // 2023-08-02 孕产加特惠馆项目
    // 孕产特惠馆自营商家产品不需要服务人员、服务门店、服务时间
    // isNeedServiceMan: 1 需要 / 0 不需要
    hideServeCompsYunChanJiaTHG() {
      return (
        [SKUTAG.SELFSTORE, SKUTAG.SELFHOME].includes(this.skuTag) &&
        this.product &&
        this.product.skuInfo &&
        this.product.skuInfo.isNeedServiceMan === 0
      )
    },
    hasStudent() {
      return SKUTAGNEED[this.skuTag] && SKUTAGNEED[this.skuTag].student
    },
    hasWorker() {
      return SKUTAGNEED[this.skuTag] && SKUTAGNEED[this.skuTag].worker
    },
    hasTime() {
      return SKUTAGNEED[this.skuTag] && SKUTAGNEED[this.skuTag].time
    },
    hasStore() {
      return SKUTAGNEED[this.skuTag] && SKUTAGNEED[this.skuTag].store
    },
    customList() {
      const collectInfo = this.product && this.product.collectInfo
      return collectInfo && collectInfo.custom && collectInfo.custom[0]
    },
    isTripTicket601() {
      return (
        this.product.skuInfo &&
        this.skuTag === SKUTAG.TICKET &&
        (this.product.skuInfo.skuSecType === 601 ||
          this.product.skuInfo.skuSecType === 602)
      )
    }
  },
  async created() {
    getLatAndLng().then(res => {
      if (res) this.position = res
    })
  },
  data() {
    return {
      fetching: false,
      selfPhotoChecked: false,
      position: {}
    }
  },
  methods: {
    ...mapMutations([
      'setOrderPayPrice',
      'setOrderPayScore',
      'setIsLessScore',
      'changeView',
      'setActionHeader'
    ]),
    ...mapMutationNs(['setCurrentProduct']),
    isNotNullObject(obj) {
      return Object.keys(obj).length > 0
    },
    testRequired(field, fieldset) {
      if (+field.isRequired === 0) {
        return ''
      } else if (field.val === undefined || field.val === '') {
        return `请填写${field.label}`
      } else {
        return ''
      }
    },
    testLength(field, fieldset) {
      const len = parseInt(field.maxlength, 10)
      if (isNaN(len)) {
        // console.error(`Form Check Error NaN at ${fieldset.title}-${field.label}`)
        console.error(`Form Check Error NaN at ${field.label}`)
        return ''
      } else if (len === 0) {
        return ''
      } else if (field.val === undefined) {
        return ''
      } else if (field.val.length > len) {
        return `${field.label}不可超过${len}个字`
      } else {
        return ''
      }
    },
    testRegexp(field, fieldset) {
      if (!field.isRequired && field.val === undefined && field.val === '') {
        return ''
      } else if (!field.regexp) {
        return ''
      }
      const reg = new RegExp(field.regexp)
      const t = reg.test(field.val)
      if (t) {
        return ''
      } else {
        return `${field.regtip}`
      }
    },
    selfPhotoNoticeChanged(checked) {
      this.selfPhotoChecked = checked
    },
    //参数验证
    validParams() {
      if (this.isSelfPhoto && this.selfPhotoChecked === false) {
        this.$$toast('请同意《自营摄影服务协议》')
        return false
      }

      if (
        this.isChooseCourse > 0 &&
        this.optionalCourseNum !== this.selectCourses.length
      ) {
        this.$$toast('请选择课程套餐')
        return false
      }

      // 门票检查
      if (this.isTripTicket601 && !this.tripCalendar && this.isNoCalendar) {
        this.$$toast('请选择游玩日期')
        return false
      }

      if (this.hasStudent) {
        let message = ''
        const newCL = this.customList ? [...this.customList.fields] : []
        newCL.reverse().forEach(item => {
          const value = this.studentInfo[item.labelKey].trim()
          const reg = new RegExp(item.regular)
          if (value && !reg.test(value)) {
            message = item.regularTip
          } else if (value && value.length > item.maxlength) {
            message = `${item.labelName}长度不得超过${item.maxlength}`
          }
        })
        if (message) {
          this.$$toast({
            transition: false,
            message,
            autoClose: true,
            duration: 3000
          })
          return false
        }
      }

      let thirdMsg = ''
      for (const info of this.thirdInfos) {
        const field = info.fields[0]
        const right = field.requestParams(field.val)
        if (isString(right)) {
          thirdMsg = right
          break
        }
      }
      if (thirdMsg.length > 0) {
        this.$$toast(thirdMsg)
        return false
      }
      // 通用表单检查
      let msg = ''
      this.schemeOut.forEach(fieldset => {
        fieldset.fields.forEach(field => {
          if (msg.length > 0) return

          if (this.testRequired(field, fieldset).length > 0) {
            msg = this.testRequired(field, fieldset)
            return
          } else if (this.testLength(field, fieldset).length > 0) {
            msg = this.testLength(field, fieldset)
            return
          } else if (this.testRegexp(field, fieldset).length > 0) {
            msg = this.testRegexp(field, fieldset)
            return
          }
        })
      })
      if (msg.length > 0) {
        this.$$toast(msg)
        return false
      }

      // 出行人信息检查
      // 原则上不存在出行人数为0的表单，但由于历史问题（会出现接口出参要求收集表单，但出行人为0的情况）需要前端托底兼容，
      // 故当出行人数为0时：
      // 1.隐藏相关表单
      // 2.调整相关数据校验
      // 3.提交数据时不要收集出行人
      let travelNum = 0
      if (this.product.skuInfo && this.product.skuInfo.travelNum) {
        travelNum = this.product.skuInfo.travelNum
      }
      travelNum = travelNum * this.buyNum
      if (this.schemeTravPerson && travelNum) {
        const md = this.schemeTravPerson
        const df = md.fields[0]
        if (!df.val || df.val.length === 0) {
          this.$$toast({
            transition: false,
            // message: `请选择${md.title}`,
            message: `请选择${
              this.product.skuInfo.travelPeopleShowType === 1
                ? '取票人'
                : '游客'
            }`,
            autoClose: true,
            duration: 3000
          })
          return false
        }

        if (df.val && df.val.length > 0) {
          let notMatchs = df.val.filter(item => item.ageMatch === 0)
          if (notMatchs && notMatchs.length > 0) {
            this.$$toast({
              transition: false,
              message: `请选择符合条件的游客`,
              autoClose: true,
              duration: 3000
            })

            return false
          }
        }

        // 前端临时方案travelPeopleShowType !== 1
        if (
          this.product.skuInfo.travelPeopleShowType !== 1 &&
          travelNum &&
          df.val.length !== travelNum
        ) {
          this.$$toast({
            transition: false,
            message: `请选择${travelNum}位游客`,
            autoClose: true,
            duration: 3000
          })
          return false
        }
      }

      // 取票人校验
      if (this.schemeTicketTaker) {
        const md = this.schemeTicketTaker
        const df = md.fields[0]
        if (!df.val || df.val.length === 0) {
          this.$$toast({
            transition: false,
            // message: `请选择${md.title}`,
            message: `请选择取票人`,
            autoClose: true,
            duration: 3000
          })
          return false
        }
      }

      const code =
        this.product.shareDetail && this.product.shareDetail.shareCode
      if (this.inviteCode.trim() !== code) {
        // 802800003, 80280067, C050431001, 19995247, 29000008,
        if (
          this.inviteCode.trim() &&
          !/^[a-zA-Z0-9][0-9]*$/.test(this.inviteCode)
        ) {
          this.$$toast({
            transition: false,
            message: '请输入正确的邀请码,只能输入数字和字母',
            autoClose: true,
            duration: 3000
          })
          return false
        }
      }
      if (this.fillIn && this.fillIn.remark) {
        const num = this.fillIn.remark.length
        if (num > 150) {
          this.$$toast({
            transition: false,
            message: '备注信息不能超过150个字',
            autoClose: true,
            duration: 3000
          })
          return false
        }
      }
      if (this.requiredCombosNum > 0 && this.selectedCombos.length == 0) {
        this.$$toast({
          transition: false,
          message: '请选择套餐项目',
          autoClose: true,
          duration: 3000
        })
        return false
      }
      return true
    },
    confirmBuy() {
      this.submitTrackParams && this.$$newTrackClick(this.submitTrackParams)
      if (!this.validParams()) {
        return false
      }
      if (
        this.supportInsurance &&
        this.selectAdultList.length === 0 &&
        this.selectChildList.length === 0
      ) {
        Msgbox({
          title: '温馨提醒',
          message:
            '孩子王赠送您免费的出行意外险，请在“出行保障”中领取后再提交订单',
          confirmButtonText: '去领保险',
          showCancelButton: true,
          confirmButtonClass: 'confirmButton',
          cancelButtonText: '直接下单',
          type: 'confirm',
          action: msgbox => {
            const product =
              this.insuranceType === InsuranceType.CHILD
                ? this.insuranceInfo?.child
                : this.insuranceInfo?.adult
            this.setCurrentProduct(product)
            this.changeView('addUserForInsurance')
            this.setActionHeader({
              show: false
            })
            this.$router.push({
              query: {
                ...this.$route.query,
                action: true,
                viewName: 'addUserForInsurance'
              }
            })
          },
          cancel: (msgbox, bb) => {
            this.doPay()
          }
        })
        return
      }

      try {
        const { reducePrice } = this
        const price =
          this.product.priceInfo.price -
            this.selectedCoupon.couponAmount -
            reducePrice <=
          0
        if (this.isSupportScore) {
          this.doPay()
        } else if (price) {
          Msgbox({
            title: '',
            message: '您使用的优惠券金额≥商品金额，确认使用该优惠券支付？',
            confirmButtonText: '确定',
            showCancelButton: true,
            confirmButtonClass: 'confirmButton',
            type: 'confirm',
            action: msgbox => {
              this.doPay()
            }
          })
        } else {
          this.doPay()
        }
      } catch (e) {
        this.doPay()
      }
    },
    // showReason() {
    //     console.log(this.product);

    //     if (this.$store.state.selectedAddress.addrid === undefined || this.$store.state.selectedAddress.addrid === '') {
    //         this.$$toast('请选择服务地址')
    //     } else if (!this.$store.state.selectedWorker.workerCode) {
    //         this.$$toast('请选择服务人员')
    //     } else if (this.$store.state.selectedTime === '') {
    //         this.$$toast('请选择服务时间')
    //     } else {
    //         this.$$toast(this.product.Reason)
    //     }
    // },
    async doPay() {
      if (this.fetching) {
        return
      }

      this.fetching = true
      const { uid, skey } = await this.$$ensureLogin()
      const shareKeyObj =
        this.$route.query.hserecomkey || this.$$cookie('hserecomkey') || ''
      let shareKey = shareKeyObj
      if (shareKeyObj instanceof Array) {
        const newShareObj = shareKeyObj.filter(v => v)
        if (newShareObj && newShareObj.length > 0) {
          shareKey = newShareObj[newShareObj.length - 1]
        }
      } else if (shareKeyObj === 'undefined') {
        shareKey = ''
      }
      shareKey = shareKey || ''

      shareKey = shareKey.toString()

      // 以前shareKey 优先赋非空inviteCode，若空赋非空shareKey本身，以下可能针对有inivitCode 工号重复的处理(场景原因不详)
      // shareKey现已不掺inviteCode，后期替换为 inviteCodeDistinct
      if (
        shareKey.length === 16 &&
        isFinite(shareKey) &&
        shareKey.substr(0, 8) === shareKey.substr(-8)
      ) {
        // 邀请码育儿顾问工号出现重复的情况
        shareKey = shareKey.substr(0, 8)
      }

      let source = 1
      if (this.$$isHZWApp()) {
        source = 2
      } else if (this.$$isCZJApp()) {
        source = 1
      } else if (this.$$isRkhy()) {
        source = 3
      } else if (await isMiniprogram()) {
        const miniAppId = this.$$cookie('miniprogramid')
        if (MINI_APPID_XYZHG === miniAppId) {
          source = 14
        } else if (MINI_APPID_TCHQZ === miniAppId) {
          source = 15
        } else {
          source = 9
        }
      } else if (isWeixin) {
        source = 8
      }

      let inviteCode = this.inviteCode.trim() || ''
      const isMmz = this.$route.query.mmz == '1'
      if (isMmz) {
        source = 16
        inviteCode = ''
      }

      let travelDate = null
      if (this.tripCalendar) {
        let { year, month, date } = this.tripCalendar
        month = `0${month}`.substr(-2)
        date = `0${date}`.substr(-2)
        travelDate = `${year}-${month}-${date}`
      }

      //学员信息
      let custom = null
      if (this.hasStudent && this.customList) {
        let fields = []

        this.customList.fields.forEach(item => {
          const { fieldId, labelName, labelKey } = item
          fields.push({
            fieldId,
            labelName,
            labelValue: this.studentInfo[labelKey],
            labelKey
          })
        })
        const { moduleId, title } = this.customList
        custom = [
          {
            moduleId,
            title,
            fields
          }
        ]
      } else {
        const filterFields = ary => {
          const fieldsF = ary.filter(oo => !isNullOrEmpty(oo.val))
          const fieldsM = fieldsF.map(oo => ({
            labelName: oo.label,
            labelKey: oo.key,
            labelValue: oo.val,
            fieldId: oo.fid
          }))
          return fieldsM
        }

        custom = this.schemeOut.map(o => ({
          title: o.title,
          moduleId: o.moduleId,
          fields: filterFields(o.fields)
        }))
      }

      const extInfo = []
      if (this.isCustomisedGoods) {
        extInfo.push({
          labelName: '定制SKU',
          labelKey: 'customisedGoods',
          labelValue: true
        })
      }
      if (
        this.hasTime &&
        this.selectedTime &&
        !this.hideServeCompsYunChanJiaTHG
      ) {
        extInfo.push({
          labelName: '服务时间', // 育儿服务
          labelKey: 'serviceTime',
          labelValue: this.selectedTime
        })
      }

      const adPlanId = this.$$cookie('ad-planid')
      if (adPlanId) {
        extInfo.push({
          labelName: '获客宝广告计划ID',
          labelKey: 'ad-planid',
          labelValue: adPlanId
        })
      }

      const liveid = this.$$cookie('liveid')
      const livestore = this.$$cookie('livestore')
      if (liveid) {
        extInfo.push({
          labelName: '直播间ID',
          labelKey: 'liveid',
          labelValue: liveid
        })
      }
      if (livestore) {
        extInfo.push({
          labelName: '设备ID',
          labelKey: 'livestore',
          labelValue: livestore
        })
      }
      //门店信息
      if (
        this.hasStore &&
        this.selectedStore &&
        !this.hideServeCompsYunChanJiaTHG
      ) {
        extInfo.push({
          labelName: '服务门店', //育儿服务/自营到店/门店编码
          labelKey: 'storeCode',
          labelValue: this.selectedStore
        })
      }
      if (this.newStoreInfo) {
        extInfo.push({
          labelName: 'POP门店', //育儿服务/自营到店/门店编码
          labelKey: 'popStoreCode',
          labelValue: this.newStoreInfo.businessKey
        })
      }
      // 套餐项目
      if (this.selectedCombos.length > 0) {
        extInfo.push({
          labelName: '套餐项目', //育儿服务/自营到店/门店编码
          labelKey: 'choosePackageItems',
          labelValue: JSON.stringify(this.selectedCombos)
        })
      }
      // 地址信息
      let deliveryAddr = null
      if (this.hasAddress) {
        deliveryAddr = {
          reqParam: {
            address: `${this.selectedAddress.province}${this.selectedAddress.city}${this.selectedAddress.district}${this.selectedAddress.address}`,
            province: this.selectedAddress.province,
            city: this.selectedAddress.city,
            regionid: this.selectedAddress.regionid,
            district: this.selectedAddress.district,
            name: this.selectedAddress.name,
            mobile: this.selectedAddress.mobile,
            addrid: this.selectedAddress.addrid,
            property: 1
          },
          moduleId: '1'
        }
      }
      //自提信息
      let pickUp = null
      if (this.pickUp) {
        const json = sessionStorage.getItem('own/address.delivery')
        if (json) {
          const val = JSON.parse(json)
          if (!val) {
            return null
          }
          pickUp = {
            moduleId: this.pickUp.moduleId,
            reqParam: {
              store: val.short_name,
              address: val.address,
              phone: val.phone,
              objId: val.business_id,
              startTime: val.start_time,
              endTime: val.end_time
            }
          }
        }
      }

      // 这个的值是数组
      // 出行人数为0时不要提交相关参数到api
      let travelPerson = null
      if (this.schemeTravPerson && this.product.skuInfo.travelNum) {
        const md = this.schemeTravPerson
        const df = md.fields[0]
        const val = df.val
        if (!val || val.length === 0) {
          return null
        }
        travelPerson = {
          moduleId: md.moduleId,
          reqParam: val.map(o => ({
            sex: o.sex,
            name: o.name,
            mobile: o.mobile,
            type: o.type,
            card: o.card,
            tpid: o.tpid
          }))
        }
      }

      let realNameTicketor = null
      if (this.schemeTicketTaker) {
        const md = this.schemeTicketTaker
        const df = md.fields[0]
        const val = df.val
        if (!val || val.length === 0) {
          return null
        }
        realNameTicketor = {
          moduleId: md.moduleId,
          reqParam: val.map(o => ({
            sex: o.sex,
            name: o.name,
            mobile: o.mobile,
            type: o.type,
            card: o.card,
            tpid: o.tpid
          }))
        }
      }

      const { reducePrice, promotionGiveVoList, reduceInfo } = this
      let orgPrice = this.product.priceInfo.price
      if (this.tripCalendar && this.tripCalendar.price) {
        orgPrice =
          this.tripCalendar.customerPrice != null
            ? this.tripCalendar.customerPrice
            : this.tripCalendar.price
      }

      const resourceOrderExtendInfos = []
      for (const info of this.thirdInfos) {
        const field = info.fields[0]
        const right = field.requestParams(field.val)
        if (!isString(right)) {
          resourceOrderExtendInfos.push(right)
        }
      }

      let selectAdultList = []
      if (this.selectAdultList.length > 0) {
        selectAdultList = this.selectAdultList.map(x => {
          return {
            recognizeeTpid: x.tpid
          }
        })
      }

      //保险相关
      let selectChildList = []
      if (
        this.selectChildList.length > 0 &&
        this.guardianInfo &&
        this.guardianInfo.tpid
      ) {
        selectChildList = this.selectChildList.map(x => {
          return {
            recognizeeTpid: x.tpid,
            insureTpid: this.guardianInfo.tpid
          }
        })
      }

      /* eslint-disable */
      const params = {
        uid,
        skey,
        skuId: this.product.skuInfo.skuId,
        orderPrice: orgPrice * this.buyNum, // 订单金额
        payPrice: Math.round(this.price * 100), // 实付金额
        couponPwd: this.selectedCoupon.couponPassword || '', // 优惠券码
        remark: this.remark || '', // 备注
        orderSource: source, // 订单来源1-APP 8-h5
        collectInfo: {
          deliveryAddr,
          custom,
          travelPerson,
          realNameTicketor,
          pickUp
        },
        extInfo,
        channelType: this.$route.query.ruleType || 1, // 订单类型1、系统下单 2、一元购下单 3、抢购下单 4、团购下单 5、积分下单(必填) 7、立减
        activityId: this.$route.query.ruleId || '', // 订单类型为2,3,4,5必填
        groupId: this.$route.query.groupId || '', // 订单类型为4,(非必填,开团不填，参团必填)
        shareKey, // 分享key
        num: this.buyNum, // 下单份数
        travelDate,
        serviceCode: this.selectedWorker.workerCode || '', // 服务人员工号
        inviteCode: inviteCode,
        reducePrice,
        promotionGiveVoList,
        isPayPeriod: 0,
        module: this.$route.query.module || '',
        longitude: this.position.lng || '',
        latitude: this.position.lat || '',
        spotId: this.spotId || '',
        resourceOrderExtendInfos: resourceOrderExtendInfos,
        insureUserInfo: selectAdultList.concat(selectChildList),
        insureStartDate: this.startTime || ''
      }

      if (this.isSupportScore) {
        params.blessPayType = 1
        params.payScore = this.payScore
      }

      // console.log('payPrice',params.payPrice)
      if (!isEmptyObject(reduceInfo)) {
        params.channelType = E_PROMOTION_TYPE.DISCOUNT
        params.activityId = reduceInfo.ruleId
      }

      if (!this.isAllPayType) {
        const { payPeriodInfo = {} } = this.product.skuInfo
        params.isPayPeriod = 1
        params.payPeriodVo = {
          preOrderPrice: payPeriodInfo.paymentDepositPrice,
          prePayPrice: payPeriodInfo.paymentDepositPrice,
          endOrderPrice:
            this.product.priceInfo.price - payPeriodInfo.paymentDepositPrice,
          endPayPrice: params.payPrice - payPeriodInfo.paymentDepositPrice
        }
      }
      if (params.payPrice < 0) params.payPrice = 0

      // 赠品单要关联母单号
      const {
        query: { relOrderId }
      } = this.$route
      if (relOrderId) {
        params.relOrderId = relOrderId
      }

      //自营摄影
      params.isSelfPhoto = this.isSelfPhoto

      //课程以逗号隔开
      if (this.optionalCourseNum) {
        params.courseIds = this.selectCourses?.map(i => i.id).join(',')
        console.log(params.courseIds)
      }

      // console.log(params)
      Toast.loading({
        duration: 0,
        message: '订单创建中...',
        forbidClick: false
      })
      const res = await this.$store.dispatch('createOrder', params)
      Toast.clear()
      const order_res = res.data || {}
      // 因为付款成功之后需要使用母订单订单号查看订单详情，顾存在localStorage里边
      // localStorage.setItem('parentOrderId',order_res.orderId)
      setOrderId(order_res.orderId)
      this.fetching = false
      if (order_res.orderId) {
        this.$$cookie.remove('liveid')
        this.$$cookie.remove('livestore')
        this.$$cookie.remove('ad-planid')
        this.gotoCashier(
          order_res.state * 1,
          order_res.payOrderId ? order_res.payOrderId : order_res.orderId,
          order_res.partnerId
        )
        // if (this.$$getDevice() === 'ios' || this.$$getDevice() === 'android') {
        //   const leftCoupon = this.couponList.filter(
        //     (ele) => ele.Code !== this.selectedCoupon.Code,
        //   )
        // this.$store.commit('setCouponList', leftCoupon)
        // this.$store.commit('setSelectedCoupon', {})
        // }
      } else if (+res.code === 4) {
        this.$$login()
      } else {
        if (res.code == '200') {
          Msgbox({
            message: res.msg
          })
        } else {
          this.$$toast(res.msg)
        }
      }
    },
    //确认订单 去支付
    gotoCashier(state, orderId, partId) {
      let url = ''
      if (state === 2) {
        //不需要支付
        url = `${this.$$hostname(
          'life'
        )}/v/order/pay-success?orderCode=${orderId}&cmd=share&sharetype=0&refresh=no`
      } else {
        if (this.isPos) {
          url = `/v/order/payment/${orderId}?cmd=share&sharetype=0&refresh=no`
        } else {
          let partnerid =
            ORDER_BELONG_BUSI_ENUM.CZJ == this.product.skuInfo.businessType
              ? '3005'
              : '3004'
          let platformid =
            ORDER_BELONG_BUSI_ENUM.CZJ == this.product.skuInfo.businessType
              ? '1'
              : '2'
          //TODO 兼容携程景区
          if (partId === '3007') {
            partnerid = '3007'
            platformid = '1'
          }
          if (partId === '3008') {
            partnerid = '3008'
            platformid = '1'
          }
          let cashierUrl = `${this.$$hostname(
            'cashier'
          )}/query/${orderId}?partnerid=${partnerid}&dealcode=${orderId}&platformid=${platformid}&cmd=share&sharetype=0`

          if (this.$$isHZWApp() && this.isOpenAppCashier) {
            cashierUrl = `${this.$$hostname(
              'cashier'
            )}/query/${orderId}?partnerid=${partnerid}&dealcode=${orderId}&platformid=${platformid}&cmd=khzwcashier`
          }

          url = `${cashierUrl}&uid=${this.$$cookie('uid')}&skey=${this.$$cookie(
            'skey'
          )}`
        }
      }
      const str = `uid: ${this.$$cookie('uid')}, link: ${encodeURIComponent(
        url
      )}`
      this.$store.dispatch('sendLog', str)
      location.href = url
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';

.actionbar {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 10;
  background: #fff;
  min-height: rem(100px);
  .action-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    height: 1rem;
    padding: 0 rem(24px);
  }
  .action-others {
    display: flex;
    align-items: center;

    li {
      flex: 1;
      flex-basis: 0;
      font-size: rem(24px);
      display: flex;
      align-items: center;
      line-height: rem(56px);

      p {
        color: #ff5900;
        font-weight: 500;

        i {
          font-size: rem(24px);
        }
        span {
          padding-left: rem(4px);
          font-size: rem(40px);
        }
      }
      .pay-score {
        display: flex;
        align-items: center;
        line-height: normal;
        color: #ff5900;
        font-weight: 600;
        font-size: rem(40px);
        span {
          font-size: rem(24px);
          margin-left: rem(4px);
        }
      }
      .less-score {
        padding: 0 rem(16px);
        color: #999999;
        font-size: rem(20px);
        line-height: rem(32px);
        border-radius: rem(16px);
        background: #e9e9e9;
        margin-left: rem(12px);
      }
    }
  }
  .action-prepay {
    display: flex;
    flex-direction: column;
    .prepay {
      span {
        font-size: rem(26px);
        color: #000000;
      }
      span:last-child {
        font-weight: 500;
        font-size: rem(36px);
        color: #ff5900;
      }
    }
    .nextpay {
      padding-top: rem(7px);
      font-size: rem(20px);
      color: #ff8800;
    }
  }
  .btns {
    display: block;
    flex: none;
    width: rem(208px);
    text-align: center;
    line-height: rem(72px);
    color: #fff;
    font-size: rem(26px);

    border-radius: rem(40px);
  }
  .btn-pink {
    background-image: linear-gradient(90deg, #ff8800 0%, #ff5900 100%);
  }
  .btn-grey {
    background: #ccc;
  }
}
</style>
<style>
.mint-msgbox-message.mint-msgbox-message {
  line-height: 1.5;
}
</style>
